import { HomeLightningBoltIcon } from './HomeLightningBoltIcon';

/**
 * author: Michael Irigoyen
 * id 077E7728-7FDE-4846-9F55-9818EB397D58
 * name home-lightning-bolt
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lightning-bolt.svg
 * tags
 * - Home Automation 
 */
export const HouseFlashIcon = HomeLightningBoltIcon;
export default HouseFlashIcon